import camelCase from '../lib/camelCase';
import Immutable from 'immutable';

function transformObject(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => transformObject(item));
    }

    if (obj.createdAt) obj.createdAt = new Date(obj.createdAt);
    if (obj.updatedAt) obj.updatedAt = new Date(obj.updatedAt);
    if (obj.deletedAt) obj.deletedAt = new Date(obj.deletedAt);
    return obj;
}

function transformOrdersFromApi(payload) {
    const result = transformObject(camelCase(payload));
    // return result.map(book => {
    //     if (book.locations) book.locations = transformObject(book.locations);
    //     return book;
    // });
    return result;
}

export function get(api) {
    return api.get(api.url('orders/my'), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformOrdersFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
};
